import { ThemeComponent } from "@/theme/ThemeComponent";
import { Component, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { CartItemRow } from "./CartItemRow";
import { cart } from "@/theme/Cart";
import { QuantitySpinner } from "../QuantitySpinner/QuantitySpinner";
import { DrawerHeader } from "../Drawer/DrawerHeader";
import { debounce } from 'lodash';
import { formatMoney } from '@/utils/formatting';

@Component
export class CartMain extends ThemeComponent {
    @Ref() summary!: HTMLAnchorElement;
    @Ref() emptyCart!: HTMLElement;
    @Ref({ required: false }) cartHeadings!: HTMLElement;
    @Ref() promoBanner!: HTMLElement;
    @Ref() items!: HTMLElement;
    @Ref({ required: false }) count!: HTMLElement;
    @Ref({ required: false }) totalPrice!: HTMLElement;
    @Ref({ required: false }) continueShoppping!: HTMLButtonElement;

    protected strings = this.dataset.strings? this.dataset.strings: '';
    private itemCount: number = 0;

    private _onCartItemCountChange = new SimpleEvent<number>();

    public get onCartItemCountChange() {
        return this._onCartItemCountChange.asEvent();
    }

    public changeCartItemCount(itemCount: number) {
        this.itemCount = itemCount;

        // Use the private backing field to dispatch
        this._onCartItemCountChange.dispatch(itemCount);
    }


    /**
     * Initialise.
     */
    init() {
        this.$subscribe(cart.onChange, debounce(() => this.cartUpdated(), 300));
        this.cartUpdated();
        this.checkFreeGift();
        this.setListeners();
    }

    setListeners() {
        if (this.continueShoppping) {
            this.$listen(this.continueShoppping, 'click', () => {
                // Locate the side cart drawer header
                const sideCartDrawerHeader = document.querySelector('.side-cart__drawer drawer-header') as DrawerHeader;
                if (sideCartDrawerHeader) {
                    sideCartDrawerHeader.changeClose('close');
                }
            });
        }
    }

    /**
     * Update item count.
     * @param count - count
     */
    updateCount(count:number) {
        if (this.count) {
            this.count.innerHTML = String(count);
        }
        this._onCartItemCountChange.dispatch(this.itemCount);

    }

    /**
     * Update Cart
     * @param container - items container.
     * @param emptyCart - cart empty message.
     * @returns
     */
    cartUpdated() {
        const itemsLength = cart.items.length;
        this.items.innerHTML = '';

        let length = 0;

        if (itemsLength <= 0) {
            this.emptyCart.style.display = 'block';
            this.summary.style.display ='none';
            if (this.cartHeadings) {
                this.cartHeadings.classList.remove('cart__headings--active');
            }
            return;
        }
        if (this.cartHeadings) {
            this.cartHeadings.classList.add('cart__headings--active');
        }
        this.emptyCart.style.display = 'none';
        this.summary.style.display ='block';
        this.itemCount = 0;

        for (const item of cart.items) {
            const row = new CartItemRow(item, new QuantitySpinner(1 , 99, item.quantity), this.strings);

            this.itemCount += item.quantity; length++;
            this.items.append(row);

            if (length < itemsLength) { continue; }
            this.updateCount(this.itemCount);
        }

        if (this.totalPrice) {
            this.totalPrice.innerHTML = formatMoney(cart.totalPrice) as string;
        }
    }

    /**
     * Cheeck if eligible for free gift.
     * - free gift query is defined within Cart.ts
     */
    checkFreeGift() {
        this.promoBanner.style.display = cart.qualifiesForFreeGift ? '' : 'none';
    }
}
